import axiosInstance from '../utils/axiosConfig';

/**
 * Payment runs (ledger row 120): approved supplier invoices handed to
 * accounting to pay. Every rule -- what is payable, which accounts, which
 * companies -- is decided by the server; this file only carries the answers.
 */
const BASE = '/api/invoicing/payment-runs/';
const XLSX = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';

export const fetchPaymentRunCompanies = async () => {
  const { data } = await axiosInstance.get(`${BASE}companies/`);
  return data;
};

export const previewPaymentRun = async (companyId, runDate, costCategory = '') => {
  const { data } = await axiosInstance.get(`${BASE}preview/`, {
    params: { hms_entity: companyId, run_date: runDate, ...(costCategory ? { cost_category: costCategory } : {}) },
  });
  return data;
};

export const createPaymentRun = async (payload) => {
  const { data } = await axiosInstance.post(BASE, payload);
  return data;
};

export const listPaymentRuns = async () => {
  const { data } = await axiosInstance.get(BASE);
  return data;
};

export const cancelPaymentRun = async (runId) => {
  const { data } = await axiosInstance.post(`${BASE}${runId}/cancel/`);
  return data;
};

/** Same name the server gives the file, so a re-download lands beside the first. */
export const paymentRunFilename = (run) => {
  const company = (run.hms_entity?.name || '').replace(/[^A-Za-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
  return `payment-run-${run.reference}-${company}-${run.run_date}.xlsx`;
};

/**
 * A refusal on a file download arrives as a Blob, which the shared error
 * helper cannot read -- so "not found" would surface as a generic failure.
 * Turn it back into the JSON the server sent.
 */
const readBlobError = async (error) => {
  const data = error?.response?.data;
  if (typeof Blob !== 'undefined' && data instanceof Blob) {
    try {
      error.response.data = JSON.parse(await data.text());
    } catch (_) {
      // Not JSON: leave it; the caller's fallback sentence applies.
    }
  }
  return error;
};

export const downloadPaymentRunExcel = async (run) => {
  let response;
  try {
    response = await axiosInstance.get(`${BASE}${run.id}/excel/`, { responseType: 'blob' });
  } catch (error) {
    throw await readBlobError(error);
  }
  const url = window.URL.createObjectURL(new Blob([response.data], { type: XLSX }));
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', paymentRunFilename(run));
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(url);
};
